module.exports = __webpack_public_path__ + "static/media/hourglass.03aaaf5c.png";